import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpLeftChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.636 0L16 6.364H6.364V16L0 9.636V0z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpLeftChevron
